import type { WindowDescriptor } from '@krp/client-runtime'

import type { OneCUiState } from '../../state'
import { decodeChosenWarehouse, warehouseChosen } from './model/warehouseChoiceSlice'
import { selectChosenWarehouse } from './model/selectors'

/**
 * Окно инвентаризации 1С (UB1d). Адрес содержит `:rid` (D-064): обход склада
 * одной базы не перепривязывается выбором другой. Вкладка помнит выбранный
 * склад этой базы (он же сохраняется на устройстве); строки обхода — на
 * сервере, их вкладка не хранит.
 */
export const ONEC_INVENTORY_WINDOWS = {
  inventory: 'onec.inventory',
} as const

export const inventoryWindows: readonly WindowDescriptor<OneCUiState>[] = [
  {
    kind: ONEC_INVENTORY_WINDOWS.inventory,
    scope: 'resource',
    paths: ['/onec/:rid/inventory'],
    label: 'Инвентаризация 1С',
    size: 'full',
    capture: (state, params) => ({ warehouse: selectChosenWarehouse(state.inventoryWarehouse, params.rid ?? '') ?? null }),
    restore: (snapshot, params) => {
      const warehouse = decodeChosenWarehouse(snapshot.warehouse)
      return warehouse === undefined || params.rid === undefined ? [] : [warehouseChosen({ resourceId: params.rid, warehouse })]
    },
  },
]
